import { signal } from "@preact/signals-react";

export const activeMusicManagerView = signal<"search" | "playlist" | "history" | "tagFrequency">(
  "search",
);
